import { useQuery } from '@tanstack/react-query';
import { useAuthenticatedAxios } from '../useAuthenticatedAxios';
import { adminUserKeys } from './adminUsers.key';
import { AdminUser } from './adminUsers.types';

export function useGetAdminUsers(options?: { enabled?: boolean }) {
  const getAxios = useAuthenticatedAxios();

  return useQuery({
    queryKey: adminUserKeys.list,
    queryFn: async () => {
      const axios = await getAxios();
      const res = await axios.get<AdminUser[]>('/api/v1/admin-users');
      return res.data;
    },
    enabled: options?.enabled ?? true,
  });
}
